/**
 * 会话 ID 存储：localStorage 持久化 sessionId。
 * 阶段三（服务端会话）前的过渡实现；刷新页面后可恢复同一会话。
 */

const SESSION_KEY = "jiangcheng-agent-session-v1";
const SESSION_PREFIX = "s_";

function readStored(): string {
  try {
    const value = window.localStorage.getItem(SESSION_KEY);
    return value || "";
  } catch {
    return "";
  }
}

function writeStored(sessionId: string): void {
  try {
    window.localStorage.setItem(SESSION_KEY, sessionId);
  } catch {
    // localStorage 不可用时忽略（仅丢失跨刷新记忆）
  }
}

function generateSessionId(): string {
  const random =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID().replace(/-/g, "")
      : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
  return `${SESSION_PREFIX}${random}`;
}

/** 获取或创建会话 ID（幂等） */
export function getOrCreateSessionId(): string {
  const stored = readStored();
  if (stored && stored.startsWith(SESSION_PREFIX)) {
    return stored;
  }
  const sessionId = generateSessionId();
  writeStored(sessionId);
  return sessionId;
}

/** 显式重置会话（例如会话过期重建） */
export function resetSessionId(): string {
  const sessionId = generateSessionId();
  writeStored(sessionId);
  return sessionId;
}
